import { Config } from 'vuescroll';

export default class Helpers {
  public static Swap(arr: any[], idx1: number, idx2: number) {
    const newArr = this.DeepCopy(arr);
    const tmp = arr[idx1];
    arr[idx1] = arr[idx2];
    arr[idx2] = tmp;
    return newArr;
  }

  public static DeepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  public static GetVueScrollOptions(): Config {
    return {
      scrollPanel: {
        scrollingX: false
      },
      rail: {
        background: '#01a99a',
        specifyBorderRadius: false,
        opacity: 0
      },
      bar: {
        background: '#e90',
        specifyBorderRadius: false,
        opacity: 0.5,
        onlyShowBarOnScroll: true,
        keepShow: true,
        minSize: 0,
        disable: false,
        // hoverStyle: {
        //   opacity: '1'
        // },
        verticalNativeBarPos: 'right'
      },
      vuescroll: {
        // sizeStrategy: 'number',
        // detectResize: false,
        snapping: {
          enable: true,
          height: 100
        },
        // mode: 'slide',
        scroller: {
          preventDefault: false
        }
      }
    };
  };
}